
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor-awareness",
      function () {
        return require("private-next-pages/investor-awareness/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor-awareness"])
      });
    }
  